import React from 'react';

export default function ConversionFlowHeader({
    flow,
    className = 'h5 mt-2 mt-lg-0 mb-2 mb-lg-4'
}) {
    return (
        <p className={className}>
            {flow?.form?.title && (
                <>
                    <b>{flow?.form?.title}</b>
                    <br />
                </>
            )}
            {flow?.form?.intro}
        </p>
    )
}
